import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { DirectiveModule } from '@Directive/directive.module';

import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { SettingsFormComponent } from './settings-form/settings-form.component';
import { NumDisplayerComponent } from './num-displayer/num-displayer.component';
import { ResultsKpiComponent } from './results-kpi/results-kpi.component';
import { LoadingScreenComponent } from './loading-screen/loading-screen.component';
import { OrganizationCreationFormComponent } from './organization-creation-form/organization-creation-form.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DedicatedAdminOrganisationListComponent } from '../../dedicated_admin/home/dedicated-admin-organisation-list/dedicated-admin-organisation-list.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { BadgeModule } from 'primeng/badge';
import { TableModule } from 'primeng/table';
import { AccordionModule } from 'primeng/accordion';
import { MultiSelectModule } from 'primeng/multiselect';
import { SkeletonModule } from 'primeng/skeleton';
import { KnobModule } from 'primeng/knob';

import { DedidcatedAdminFormComponent } from './dedidcated-admin-form/dedidcated-admin-form.component';
import { SearchbarComponent } from './searchbar/searchbar.component';
import { SettingsFormPeriodComponent } from './settings-form/settings-form-period/settings-form-period.component';
import { SettingsFormOrganizationComponent } from './settings-form/settings-form-organization/settings-form-organization.component';
import { SettingsFormUserComponent } from './settings-form/settings-form-user/settings-form-user.component';
import { EditPeriodComponent } from './settings-form/settings-form-period/edit-period/edit-period.component';
import { ImageSelectorComponent } from './image-selector/image-selector.component';
import { SelectMeasureComponent } from './select-measure/select-measure.component';
import { SettingsFormEntitiesComponent } from './settings-form/settings-form-entities/settings-form-entities.component';
import { EditEntityComponent } from './settings-form/settings-form-entities/edit-entity/edit-entity.component';
import { FreetrialExpirationComponent } from './freetrial-expiration/freetrial-expiration.component';
import { CommonPageComponent } from './questionnaire-sections/common-page/common-page.component';
import { MobilityPageComponent } from './questionnaire-sections/mobility-page/mobility-page.component';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { QuestionComponent } from '../measure/question/question.component';
import { QuestionInstanceComponent } from '../measure/question/question-instance/question-instance.component';
import { RadioButton, RadioButtonModule } from 'primeng/radiobutton';
import { TabViewModule } from 'primeng/tabview';
import { SettingsFormUsersManagmentComponent } from './settings-form/settings-form-users-managment/settings-form-users-managment.component';
import { EditUserComponent } from './settings-form/settings-form-users-managment/edit-user/edit-user.component';
import { MenuLanguageSelectorComponent } from './menu-language-selector/menu-language-selector.component';

import { TranslatePluralPipe } from '../../pipes/translate-plural.pipe';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { StepsModule } from 'primeng/steps';
import { TermsComponent } from './terms/terms.component';
import { CheckboxModule } from 'primeng/checkbox';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CalendarModule } from 'primeng/calendar';
import { ChipsModule } from 'primeng/chips';
import { HeaderComponent } from './header/header.component';
import { TruncateWithTooltipComponent } from './truncate-with-tooltip/truncate-with-tooltip.component';

@NgModule({
    declarations: [
        LanguageSelectorComponent,
        LoadingScreenComponent,
        NumDisplayerComponent,
        ResultsKpiComponent,
        SettingsFormComponent,
        OrganizationCreationFormComponent,
        DedicatedAdminOrganisationListComponent,
        DedidcatedAdminFormComponent,
        SearchbarComponent,
        SettingsFormOrganizationComponent,
        SettingsFormUserComponent,
        SettingsFormPeriodComponent,
        TranslatePluralPipe,
        EditPeriodComponent,
        ImageSelectorComponent,
        SelectMeasureComponent,
        SettingsFormEntitiesComponent,
        EditEntityComponent,
        CommonPageComponent,
        MobilityPageComponent,
        QuestionComponent,
        QuestionInstanceComponent,
        FreetrialExpirationComponent,
        SettingsFormUsersManagmentComponent,
        EditUserComponent,
        MenuLanguageSelectorComponent,
        OnboardingComponent,
        TermsComponent,
        HeaderComponent,
        TruncateWithTooltipComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        DirectiveModule,
        // PrimeNG Modules
        AutoCompleteModule,
        CalendarModule,
        ChipsModule,
        ConfirmDialogModule,
        ButtonModule,
        DialogModule,
        DynamicDialogModule,
        DropdownModule,
        InputMaskModule,
        InputNumberModule,
        InputTextModule,
        PasswordModule,
        ScrollPanelModule,
        TooltipModule,
        TableModule,
        TabViewModule,
        AccordionModule,
        AvatarModule,
        AvatarGroupModule,
        BadgeModule,
        RadioButtonModule,
        MultiSelectModule,
        StepsModule,
        CheckboxModule,
        ProgressSpinnerModule,
        SkeletonModule,
        KnobModule,
    ],
    exports: [
        DedidcatedAdminFormComponent,
        DedicatedAdminOrganisationListComponent,
        FreetrialExpirationComponent,
        OrganizationCreationFormComponent,
        LanguageSelectorComponent,
        LoadingScreenComponent,
        NumDisplayerComponent,
        ResultsKpiComponent,
        SettingsFormComponent,
        SearchbarComponent,
        SelectMeasureComponent,
        TranslatePluralPipe,
        ImageSelectorComponent,
        MenuLanguageSelectorComponent,
        HeaderComponent,
        TruncateWithTooltipComponent,
    ],
})
export class ComponentsModule {}
